/**
 * PLAINS256 for this browser (lane C0-P1): the 256 m plains are on by default (packages/shared data/zones.ts
 * `PLAINS256`, on since 2026-10-10, after the perf gate: docs/research/C0_SCENE_PLAINS.md §9).
 * `localStorage['c0.plains256'] = '0'` goes back to the 72 m map (the rollback) for this browser. Not a menu setting.
 */
import { setPlains256 } from '@nine/shared';

let on = true;
try {
  on = localStorage.getItem('c0.plains256') !== '0';
} catch {
  // No storage (a sandboxed frame): on.
}
setPlains256(on);
